import { ChangeDetectorRef, Component, EventEmitter, Input, input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../app/auth/services/auth.service';
import { SharedService } from '../../services/shared.service';
import { User } from '../../../app/admin-panel/components/pages/user/models/user';
import { Permission } from '../../models/permission';
import { LocalStorageKeysEnum } from '../../models/localStorageKeys-enum';
import { SharedModule } from '../../shared-module';

@Component({
  selector: 'app-user-detail',
  standalone: true,
  imports: [CommonModule,SharedModule],
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
  @Input() isUserSession: boolean = false;
  showUserOptionDropdown:boolean=false;
  isAdmin!:boolean;
  isReviewer!:boolean;
  isContributor!:boolean;
  loading!:boolean;
  user:User=new User();
  isUserLogin:boolean=false;
  intervalId: any;
  constructor(
    private cdr:ChangeDetectorRef,
    public authService:AuthService,
    public router:Router,
    private sharedService:SharedService,

  ) {

    }

   ngOnInit():void {
    this.isUserLogin=this.authService.isUserLogin();;
    this.isAdmin=this.authService.hasPermission(Permission.Admin);
    this.isReviewer=this.authService.hasPermission(Permission.Reviewer);
    this.isContributor=this.authService.hasPermission(Permission.Contributor);
    this.user=this.sharedService.getUserInfo();
    
    this.authService.refreshComponent$.subscribe((response: boolean) => {
      if (response) {
        this.isUserLogin = this.authService.isUserLogin();
        this.isAdmin = this.authService.hasPermission(Permission.Admin);
        this.isReviewer = this.authService.hasPermission(Permission.Reviewer);
        this.isContributor = this.authService.hasPermission(Permission.Contributor);
        this.user = this.sharedService.getUserInfo();
        this.showUserOptionDropdown = false;
        this.cdr.detectChanges();
      }
    });

  }

  /** Admin lands on Customers; Reviewer-only lands on Category. */
  get adminPanelEntryRoute(): string {
    return this.isAdmin ? '/admin-panel/customer' : '/admin-panel/category';
  }

  get canSwitchToAdminPanel(): boolean {
    return (this.isAdmin || this.isReviewer) && !this.router.url.includes('admin-panel') && this.isUserLogin;
  }

  getSwitchStatus():string{
      return this.router.url.includes('admin-panel') ? 'Reviewer' : 'Admin-Panel';
  }
  navigate(){
    const url:string=this.router.url.includes('admin-panel') ? '' : this.adminPanelEntryRoute;
    this.router.navigate([url])
  }
  goToProfile():void{
    this.router.navigate(['/profile/account'])
  }
  goToDownloads():void{
    this.router.navigate(['/profile/downloads'])
  }
  goToCollections():void{
    this.router.navigate(['/profile/collections'])
  }

  logout():void{
    this.authService.logout(false,true);
  }
  navigateToPlansAndPricing():void{
    const url:string=this.isUserLogin ? '/profile/pricing': '/pricing';
    this.router.navigate([url]);
  }
  navigateToContributor():void{
    // const url:string= !this.isUserLogin ? '/auth/login' : '/profile/contributor/upload';
    // if(!this.isUserLogin){
    //   const gateway:string = this.isUserLogin ? 'login' : 'become-a-contributor';
    //   const route:string='/profile/contributor/upload';
    //   const navigationObject:NavigationObject=NavigationObjectMapper.map(gateway,route);
    //   localStorage.setItem('navigation',JSON.stringify(navigationObject))
    // }
    // this.router.navigate([url]);

  }
}
